var _rect, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBearerOnlineWalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 42,
    viewBox: "0 0 28 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7719,
    y: 17.193,
    width: 1.96491,
    height: 22.5965,
    rx: 0.982456,
    fill: "#FF8A29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#FF8A29",
    stroke: "#DB7723",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7982 22.7807V17.9912L13.1219 16.3947L12.3237 19.907L6.81579 18.7895L7.13509 17.193L10.9667 17.9912L12.2439 11.5254L10.807 12.0842V14.7982H9.21053V11.0465L12.3636 9.68947C12.8292 9.48991 13.1718 9.36019 13.3913 9.30032C13.6109 9.24046 13.8137 9.21052 14 9.21052C14.2794 9.21052 14.5388 9.28369 14.7783 9.43004C15.0178 9.57638 15.2107 9.76929 15.357 10.0088L16.1553 11.286C16.5012 11.8447 16.9701 12.3037 17.5622 12.6629C18.1542 13.0221 18.8294 13.2017 19.5877 13.2017V14.7982C18.7096 14.7982 17.8881 14.6153 17.1231 14.2494C16.3581 13.8836 15.7162 13.4013 15.1974 12.8026L14.7184 15.1974L16.3947 16.7939V22.7807H14.7982ZM15.1974 8.8114C14.7583 8.8114 14.3825 8.65508 14.0698 8.34243C13.7572 8.02978 13.6009 7.65394 13.6009 7.21491C13.6009 6.77587 13.7572 6.40003 14.0698 6.08739C14.3825 5.77474 14.7583 5.61842 15.1974 5.61842C15.6364 5.61842 16.0122 5.77474 16.3249 6.08739C16.6375 6.40003 16.7939 6.77587 16.7939 7.21491C16.7939 7.65394 16.6375 8.02978 16.3249 8.34243C16.0122 8.65508 15.6364 8.8114 15.1974 8.8114Z",
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearerOnlineWalk);
export default __webpack_public_path__ + "static/media/bearer-online-walk.56e8b5d785e0cf6bc7f14632985d0549.svg";
export { ForwardRef as ReactComponent };